import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import {
  extractPowerLocationIdFromPath,
  isSubscriptionPurchasePath,
} from '../utils/subscription';

const ProtectedRoute = ({ children, requiredRole, userRole, isInitializing }) => {
  const location = useLocation();
  const {
    isLoading: subscriptionLoading,
    requiresPurchase,
    hasActiveSubscriptionForPlant,
    isResolved: subscriptionResolved,
  } = useSubscription();

  if (isInitializing) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
      }}>
        로딩 중...
      </div>
    );
  }

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  if (userRole === 'ADMIN' && location.pathname === '/') {
    return <Navigate to="/admin" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (userRole === 'USER') {
    if (subscriptionLoading) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
        }}>
          이용 기간 확인 중...
        </div>
      );
    }

    const powerLocationId = extractPowerLocationIdFromPath(location.pathname);
    if (
      powerLocationId &&
      subscriptionResolved &&
      !hasActiveSubscriptionForPlant(powerLocationId)
    ) {
      return (
        <Navigate
          to="/products"
          replace
          state={{ powerLocationId, from: location.pathname }}
        />
      );
    }

    if (requiresPurchase && !isSubscriptionPurchasePath(location.pathname)) {
      return <Navigate to="/products" replace state={{ from: location.pathname }} />;
    }
  }

  return children;
};

export default ProtectedRoute;
